import t from 'react-translate';
import { getMentoringProgramAliases } from 'redux/selectors/mentoring-programs';
import MentoringProgramContext from '../../context';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/react';
import { textSmallLineHeight } from 'styles/global_defaults/fonts';
import { gray2 } from 'styles/global_defaults/colors';

const styles = css`
  .participant-driven-content {
    line-height: ${textSmallLineHeight}px;
  }
  .participant-driven-details {
    color: ${gray2} !important;
  }
`;

const ParticipantDrivenMatchingConfiguration = () => {
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const mentoringProgramAliases = useSelector((state) =>
    getMentoringProgramAliases(state, mentoringProgram.id)
  );
  const translationBase =
    t.MENTORING_PROGRAMS.SETTINGS.TABS.MATCHING_SETTINGS.MATCHING_TYPE
      .CONFIGURATION.PARTICIPANT_DRIVEN;

  return (
    <div css={styles} className='py-4 px-2'>
      <div className='pb-1 text-align-center text-regular participant-driven-content semi-bold gray-1'>
        {translationBase.CONTENT()}
      </div>
      <div className='text-align-center text-body participant-driven-details'>
        {translationBase.DETAILS(mentoringProgramAliases)}
      </div>
    </div>
  );
};

export default ParticipantDrivenMatchingConfiguration;
